module.exports = __webpack_public_path__ + "static/img/u1425.63581663.png";